import { IDashboardStat } from '../../../../ts/interface/dashboardStats.interface';

/**
 * The snapshot counters as organizationStats and systemStats return them.
 *
 * Both stats types expose the identical set, so the org and system dashboards
 * share this mapping. Every field is a nullable Int in the schema, hence the
 * defaulting: the API answers null only when it cannot attribute a counter to
 * the caller's permissions, which reads as zero on a tile.
 */
export interface ISnapshotCounters {
  readonly activeRentalsCount?: number | null;
  readonly rentalsCount?: number | null;
  readonly usersCount?: number | null;
  readonly availableHardwareCount?: number | null;
}

export function toDashboardStat(counters: ISnapshotCounters): IDashboardStat {
  return {
    active_rentals: counters.activeRentalsCount ?? 0,
    total_rentals: counters.rentalsCount ?? 0,
    total_users: counters.usersCount ?? 0,
    available_hardware: counters.availableHardwareCount ?? 0,
  };
}
